export const LanguageRepositoryToken = Symbol('LanguageRepository');
export const FacilityRepositoryToken = Symbol('FacilityRepository');
export const BrandFactoryToken = Symbol('BrandFactory');
export const UserRepositoryToken = Symbol('UserRepository');
export const EventPublisherToken = Symbol('EventPublisher');
export const SubscriptionPlanRepositoryToken = Symbol('SubscriptionPlanRepository');
